import React from 'react';
export const AboutSection = () => {
  return <section className="py-20 bg-gray-50" data-id="element-13">
      <div className="container mx-auto px-4" data-id="element-14">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-15">
          <div className="md:w-1/2" data-id="element-16">
            <div className="rounded-lg overflow-hidden shadow-xl" data-id="element-17">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3GQxqrk1ikBPaTwwemDeq3/ChatGPT_Image_22_jun_2025%2C_15_14_07.png" alt="Marco, eigenaar van Marco Leer, met leermateriaal" className="w-full h-auto object-cover" data-id="element-18" />
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-19">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-20">Over Marco</h2>
            <p className="text-lg mb-4 leading-relaxed" data-id="element-21">
              Al meer dan 35 jaar is Marco Leer een begrip in de wereld van
              bootstoffering. Wat begon als een passie voor vakmanschap en
              kwaliteit, groeide uit tot een familiebedrijf dat staat voor
              vertrouwen en expertise.
            </p>
            <p className="text-lg mb-4 leading-relaxed" data-id="element-22">
              Sinds 1988 hebben we honderden boten en jachten voorzien van
              hoogwaardige stoffering die niet alleen mooi is, maar ook bestand
              tegen de uitdagende omstandigheden op het water.
            </p>
            <p className="text-lg leading-relaxed" data-id="element-23">
              Bij Marco Leer begrijpen we dat uw boot meer is dan alleen een
              vervoermiddel – het is een plek van ontspanning en plezier. Daarom
              behandelen we elk project met de aandacht en precisie die het
              verdient.
            </p>
          </div>
        </div>
      </div>
    </section>;
};